module.exports = __webpack_public_path__ + "static/media/un.424ca4df.svg";